import React from 'react';
import { Col, Modal } from 'react-bootstrap';
import "./style.scss";

export default function MyModal({show,onHide,header,body}){
  return (
    <Modal 
      className='my-modal' 
      backdropClassName="my-modal-backdrop"
      show={show} 
      onHide={onHide} 
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Col>{header}</Col>
      </Modal.Header>
      <Modal.Body>
        {body}
      </Modal.Body>
    </Modal>
  );
}